import {
  frFR,
  enUS,
  ptBR,
} from '@mui/x-data-grid/locales';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

//Normalisation our keys with mui
export const muiDataGridLocales: Record<string, any> = {
  'fr-FR': frFR,
  'en-EN': enUS,
  'pt-PT': ptBR,
};

/**
 * Hook for synchronizing translations between the project (i18n) and MUI
 * Keys = i18n.language
 * Values = locale from MUI
 * 
 * Automatically updates when changing languages
 * MUI + backend translations can be mixed
 * Unified control
 */

export function useMuiDataGridLocale() {
  const { i18n, t } = useTranslation();

  return useMemo(() => {
    const locale =
      muiDataGridLocales[i18n.language] ??
      muiDataGridLocales['fr-FR'];

    const baseLocaleText =
      locale.components.MuiDataGrid.defaultProps.localeText;

    return {
      ...baseLocaleText,      
      noRowsLabel: t('Pas de résultats', { ns: 'commons' }), //when rows.length === 0
      //when the filter is applied and nothing is found
      noResultsOverlayLabel: t('Pas de résultats', { ns: 'commons' }),
    };
  }, [i18n.language, t]);
}